'use client';

import classes from '@/components/Shares/Button.module.css';
import { useLingui } from '@lingui/react';
import { ActionIcon, Card, Group, Image, SimpleGrid, Stack } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';
import Link from 'next/link';
import { Bets } from '../Bets';
import { CardTitle } from '../Shares/CardTitle';
import { data } from './data';
export const Provider: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack gap={20}>
      <Group gap={10} align="center">
        <ActionIcon component={Link} href="/" w={40} h={40} className={classes.btnIcon_2}>
          <IconChevronLeft size={20} stroke={2} />
        </ActionIcon>

        <CardTitle firstText={i18n._('Game Providers')} colorFrom="#FFFFFF" colorTo="#FFFFFF" mt={4} iconUrl="/assets/title-icons/6.png" />
      </Group>

      <SimpleGrid cols={{
      base: 2,
      sm: 3,
      md: 5
    }} spacing={20}>
        {data.map(item => <Card key={item.id} h={98} radius={5} py={24} bg="var(--bg-200)">
            <Image w={142} h={50} mx="auto" src={item.src} alt={`brand-${item.id}`} />
          </Card>)}
      </SimpleGrid>

      <Bets hasActionTab />
    </Stack>;
};